import styled from "styled-components/macro";

export const DivGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-areas:
    "dateInAv dateOutAv"
    "roomPrice deposite"
    "additionalCosts additionalCosts"
    "expectedIncome expectedIncome";
  grid-template-columns: repeat(2, 1fr);
  #dateRange {
    grid-area: dateRange;
  }

  #roomPrice {
    grid-area: roomPrice;
  }

  #deposite {
    grid-area: deposite;
  }

  #additionalCosts {
    grid-area: additionalCosts;
  }

  #expectedIncome {
    grid-area: expectedIncome;
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-areas:
      "dateInAv"
      "dateOutAv"
      "roomPrice"
      "deposite"
      "additionalCosts"
      "expectedIncome";
    grid-template-columns: 1fr;
  }
`;

export const DivFilled = styled.div`
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.secondary};
  padding: 16px;
  width: 100%;
  margin-bottom: 24px;
  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 24px;
    padding: 24px 8px;
  }
`;
